import {LanguagesStripData, Repository} from 'types';

export const getLanguages = (repo: Repository): LanguagesStripData => {
  const total = repo.languages.edges
    .reduce((sum, edge) => sum + edge.size, 0);

  if (total === 0) {
    return [];
  }

  return repo.languages.nodes.map((language, index) => {
    const edge = repo.languages.edges[index];
    const width = edge ? Math.round((edge.size / total) * 100) : 0;

    return {
      id: language.id,
      name: language.name,
      color: language.color,
      height: `${width}%`
    };
  });
};

export const getRepositorySummary = (repo: Repository): string => {
  if (repo.description) {
    return repo.description;
  }

  if (repo.readme?.text) {
    return repo.readme.text
      .replace(/^#+\s*/gm, '')
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/[-_*`>#]/g, '')
      .trim()
      .slice(0, 220);
  }

  return 'A repository from my project archive.';
};
